import { RegisterForm } from '../components/auth/RegisterForm'
import { type ShellConfig } from '../config/shell-config'

export type RegisterPageProps = {
  /** Shell configuration (provides routes and branding) */
  config: ShellConfig
  /** Override redirect URL if needed */
  redirectUrl?: string
}

/**
 * RegisterPage - A ready-to-use page component for registration
 * 
 * This component can be re-exported in derivative apps:
 * 
 * @example
 * ```tsx
 * // src/app/auth/register/page.tsx
 * import { RegisterPage } from '@korvo/shell/pages'
 * import { shellConfig } from '@/config/shell-config'
 * 
 * export default function Page() {
 *   return <RegisterPage config={shellConfig} />
 * }
 * ```
 */
export function RegisterPage({ config, redirectUrl }: RegisterPageProps) {
  return <RegisterForm config={config} redirectUrl={redirectUrl} />
}

